import { Directive } from '@angular/core';

@Directive({
    selector: '[mutaraCoder]',
    standalone: false
})
export class MutaraCoderDirective {

  constructor() { }

}
